import React from "react";
import { useNavigationEvent } from "navigation-react";

function EnquiryBanner() {
  const { stateNavigator } = useNavigationEvent();

  // const handleContact = (e) => {
  //   e.preventDefault();
  //   stateNavigator.navigate("contact");   // adjust to your actual route key
  // };

  return (
    <>
      <section className="enquiry-banner">
        <div className="enquiry-inner">
          <h2 className="enquiry-title">Ready to Make an Enquiry?</h2>
          <p className="enquiry-text">
            Reach out to us with your needs, and we will respond to you as
            quickly as possible!
          </p>
          <a
            href="/contact"
            className="enquiry-btn"
            // onClick={handleContact}
          >
            Contact Us
            <span className="enquiry-arrow">→</span>
          </a>
        </div>
      </section>

      <style>{`
        .enquiry-banner {
          width: 100%;
          padding: 90px 40px;
          background: linear-gradient(
            135deg,
            #001a3d 0%,
            #002a5c 50%,
            #0047a3 100%
          );
          font-family: Arial, sans-serif;
          box-sizing: border-box;
          text-align: center;
        }

        .enquiry-inner {
          max-width: 900px;
          margin: 0 auto;
        }

        /* ============ TITLE ============ */
        .enquiry-title {
          font-size: 30px;
          font-weight: 900;
          color: #ffffff;
          margin: 0 0 18px;
          line-height: 1.2;
          letter-spacing: 0.3px;
        }

        /* ============ SUBTITLE ============ */
        .enquiry-text {
          font-size: 18px;
          line-height: 1.6;
          color: #dbe5f0;
          margin: 0 0 32px;
          max-width: 666px;
          margin-left: auto;
          margin-right: auto;
        }

        /* ============ BUTTON ============ */
        .enquiry-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 15px 30px;
          background: #ffffff;
          color: #0a1a35;
          text-decoration: none;
          font-size: 15px;
          font-weight: 700;
          border-radius: 999px;
          transition: all 0.2s ease;
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
        }
        .enquiry-btn:hover {
          background: #f3f4f6;
          transform: translateY(-2px);
          box-shadow: 0 8px 22px rgba(0, 0, 0, 0.25);
        }
        .enquiry-arrow {
          font-size: 17px;
          display: inline-block;
          transition: transform 0.2s ease;
        }
        .enquiry-btn:hover .enquiry-arrow {
          transform: translateX(4px);
        }

        /* ============ RESPONSIVE ============ */
        @media (max-width: 800px) {
          .enquiry-banner {
            padding: 70px 24px;
          }
          .enquiry-title {
            font-size: 32px;
          }
          .enquiry-text {
            font-size: 16px;
          }
        }

        @media (max-width: 500px) {
          .enquiry-banner {
            padding: 60px 20px;
          }
          .enquiry-title {
            font-size: 26px;
          }
          .enquiry-text {
            font-size: 15px;
            margin-bottom: 26px;
          }
          .enquiry-btn {
            padding: 13px 26px;
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
}

export default EnquiryBanner;